import React, { Component } from "react";
import ReactDOM from "react-dom";
import { withRouter } from "react-router-dom";
import Loading from "../../../hoc/Loading/Loading";
import axios from "../../../axios";
import { saveAs } from "file-saver";
import html2canvas from "html2canvas";
import {
  groupContentFields,
  groupPrivacyStatusDesc,
  CANVAS_PROXY_IMAGE_URL,
} from "../../../utils/constants";
import * as actionCreators from "../../../modules/actions/index";
import { connect } from "react-redux";
import * as url from "../../../utils/url";
import { whiteLabelStyling, isUserRemoved } from "../../../utils/constants";
import moment from "moment";
import {
  Input,
  InputGroup,
  InputGroupAddon,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import LinkedChartItem from "../../weekly-wins/LinkedChartItem.jsx";
import noLinkedChart from "../../../assets/onboarding/analytics.png";
import loadingItems from "../../../assets/placeholders/kpi_available.svg";
import ExportableCharts from "./ExportableCharts";
import { isMobile } from "../../../utils/deviceInfo";

class MetricsAnalytics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: "",
      charts: [],
      chartsCopy: [],
      removeChart: [],
      isLoaded: false,
      isExporting: false,
    };
    this.analyticsRef = null;
  }

  componentDidMount() {
    let { id } = this.props.match.params;
    if (this.props.renderIntoMetricsPopup) {
      id = this.props.group._id;
    }
    let that = this;
    let payload = {
      groupId: id,
      modelName: "Chart",
      noLoader: true,
      // modelType:'action'
    };
    this.props.highlightMenu("A");
    axios.post(url.getSingleGroupItems, payload).then(({ data }) => {
      console.log("charts ---- ", data.data);
      that.setState({
        chartsCopy: [...data.data.items],
        charts: [...data.data.items],
        isLoaded: true,
      });
    });
  }

  viewAction = item => {
    this.props.history.push(`/home/planning/${item._id}`);
  };

  removeChart = item => {
    this.setState(prevState => ({
      charts: prevState.charts.filter(e => e._id != item.modelId),
    }));
  };

  renderCharts = () => {
    let { charts, isLoaded } = this.state;
    const { renderIntoMetricsPopup } = this.props;
    if (isLoaded) {
      if (charts && charts.length > 0) {
        return (
          <div
            className={`row px-1  ${
              renderIntoMetricsPopup
                ? "grp_single_page_render_analytics_grow"
                : "grp_single_page_render_analytics"
            }`}
          >
            {charts.map((item, idx) => {
              return (
                <div
                  className={
                    renderIntoMetricsPopup
                      ? `col-md-6 col-12 grp_single_page_analytics_item_container`
                      : `col-md-4 col-12 grp_single_page_analytics_item_container`
                  }
                  key={item._id + idx}
                >
                  <LinkedChartItem
                    group={this.props.group}
                    isGroups={true}
                    removeChart={this.removeChart}
                    chart={item}
                    hideRemove={renderIntoMetricsPopup ? true : false}
                  />
                </div>
              );
            })}
          </div>
        );
      } else {
        return (
          <span
            className={
              renderIntoMetricsPopup
                ? "grp_single_page_metrics cursor-pointer"
                : "grp_single_page_no_analytics cursor-pointer"
            }
          >
            <img src={noLinkedChart} className="grpNoLinkedCharts" /> No Charts
            have been linked to this group.
            <div
              className="grp_page_events_subtitle"
              onClick={() => this.props.history.push(`/home/analytics/all`)}
            >
              Click here to link analytics.{" "}
            </div>
          </span>
        );
      }
    } else {
      return (
        <div
          className={
            renderIntoMetricsPopup
              ? "grp_single_page_metrics_popup_container"
              : "grp_single_page_details_analytics_container"
          }
        >
          <span className="grp_single_page_no_analytics">
            <img src={loadingItems} className="grpNoLinkedCharts" /> Loading...
          </span>
        </div>
      );
    }
  };

  handleExportClick = () => {
    this.setState(
      {
        isExporting: true,
      },
      () => {
        setTimeout(() => {
          let node = ReactDOM.findDOMNode(this.analyticsRef);
          console.log("first", node);

          html2canvas(node, {
            useCORS: true,
            allowTaint: true,
            proxy: CANVAS_PROXY_IMAGE_URL,
          })
            .then(canvas => {
              this.setState({ isExporting: false });
              console.log("res");
              canvas.toBlob(blob => {
                let newWindow = window.open("/");
                if (newWindow) {
                  newWindow.location = URL.createObjectURL(blob);
                } else {
                  // empty
                }

                let name = "AnalyticsExport.png";
                saveAs(blob, name);
              });
            })
            .catch(err => console.log(err));
        }, 1000);
      }
    );
  };

  handleSearchQueryChanged = e => {
    const val = e.target.value;
    const { chartsCopy } = this.state;
    if (val) {
      const newCharts = chartsCopy.filter(x =>
        x.name.toLowerCase().includes(val.toLowerCase())
      );
      this.setState({ charts: [...newCharts] });
    } else {
      this.setState({ charts: [...chartsCopy] });
    }
  };

  render() {
    const { renderIntoMetricsPopup, analyticsPopupOpen, toggle } = this.props;
    const { isExporting, charts } = this.state;

    return (
      <Modal isOpen={analyticsPopupOpen}>
        <ModalHeader toggle={toggle} className="metrics-mobile-header">
          Group Analytics
          {charts.length ? (
            <span
              className={`single_group_menu_events_export_btn ${
                isMobile ? "" : "ml-5"
              }`}
              onClick={this.handleExportClick}
            >
              Export Metrics Charts
            </span>
          ) : (
            ""
          )}
        </ModalHeader>
        <ModalBody>
          <span
            className={
              renderIntoMetricsPopup ? "" : "grp_single_page_stories_container"
            }
          >
            <div className="search-export-button-div">
              <InputGroup style={{ height: "40px" }}>
                <Input
                  className="toolkit-field tool-search-box"
                  placeholder="Search ..."
                  onChange={this.handleSearchQueryChanged}
                />
                <InputGroupAddon addonType="append">
                  <i
                    style={{ color: "#818389", padding: "7px" }}
                    className="flaticon-search"
                  ></i>
                </InputGroupAddon>
              </InputGroup>
            </div>
            <div
              className={
                renderIntoMetricsPopup
                  ? "grp_single_page_metrics_popup_container analytics-metrics-height-scroll"
                  : "grp_single_page_details_analytics_container"
              }
            >
              {this.renderCharts()}
            </div>

            {renderIntoMetricsPopup &&
            isExporting &&
            this.state.charts.length ? (
              <div
                className="exportToolcontainer"
                style={{
                  display: "block",
                  position: "absolute",
                  top: "10000px",
                  zIndex: "-99999999",
                }}
                ref={r => (this.analyticsRef = r)}
              >
                <div
                  className={
                    renderIntoMetricsPopup
                      ? "grp_single_page_metrics_popup_container"
                      : "grp_single_page_details_analytics_container"
                  }
                >
                  <ExportableCharts
                    group={this.props.groups}
                    charts={this.state.charts}
                  />
                </div>
              </div>
            ) : null}
          </span>
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: dashboard => dispatch(actionCreators.updateReport(dashboard)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(MetricsAnalytics, axios)));
